import { projectStages } from 'define/calculator';

export const getDefaultConfigEn = type => ({
  id: `calculator-${type}`,
  formName: `price-${type}`,
  title: 'Request the price of the project',
  counter: false,
  sections: [
    {
      name: 'development_direction',
      type: 'development_direction',
      blockType: 'checkbox',
      counterType: 'checkbox',
      shouldShowHints: true,
      defaultValue: false,
      title: 'What type of software solution would you like to develop with Andersen?',
      mobileTitles: {
        default: 'Type of software',
        active: 'Type of software',
        section: 'Type of software',
      },
      items: ['Web', 'Mobile', 'Consultancy needed'],
      accordion: true,
      fullWidth: false,
      cols: { xl: { cols: 2 }, lg: { cols: 1 }, md: { cols: 1 } },
    },
    {
      name: 'stage',
      type: 'stage',
      blockType: 'radioButton',
      counterType: 'radio',
      totalBoxType: 'string',
      defaultValue: false,
      title: 'What is the current stage of your software development process?',
      mobileTitles: {
        default: 'Your current project stage',
        active: 'Your current project stage',
        section: 'Your current project stage',
      },
      items: projectStages,
      accordion: true,
      fullWidth: false,
      cols: { xl: { cols: 2 }, lg: { cols: 2 }, md: { cols: 2 } },
    },
    {
      name: 'professional_consultation',
      type: 'team',
      blockType: 'checkbox',
      counterType: 'checkbox',
      defaultValue: false,
      title: 'Do you need a professional consultation from any of the specialists below?',
      mobileTitles: {
        default: 'Expert consultation',
        active: 'Expert consultation',
        section: 'Expert consultation',
      },
      items: ['Project Manager', 'Business Analyst', 'UI/UX Designer', 'Architect'],
      accordion: true,
      withMT: true,
      borderBottom: false,
    },
    {
      name: 'duration',
      type: 'duration',
      blockType: 'rangeSlider',
      counterType: 'range',
      totalBoxType: 'range',
      defaultValue: false,
      initialStep: 1,
      title: 'What is the expected duration of your project?',
      mobileTitles: {
        default: 'Project duration',
        active: 'Project duration',
        section: 'Project duration',
      },
      items: [
        '1 Month',
        '2 Months',
        '3 Months',
        '4 Months',
        '5 Months',
        '6 Months',
        '7 Months',
        '8 Months',
        '9 Months',
        '10 Months',
        '11 Months',
        '12 Months',
        '13 Months',
        '14 Months',
        '15 Months',
        '16 Months',
        '17 Months',
        '18 Months',
        '19 Months',
        '20 Months',
        '21 Months',
        '22 Months',
        '23 Months',
        '24 Months',
      ],
      accordion: true,
      borderBottom: false,
    },
  ],
});
